module.exports = {
  API_URL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://app.abi.com.py/api/v1',
  BASE_URL: process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : 'https://app.abi.com.py',
  ID_ONE_SIGNAL: process.env.REACT_APP_ID_ONE_SIGNAL
    ? process.env.REACT_APP_ID_ONE_SIGNAL
    : 'dd731988-5f56-40b3-88e9-681da4519bf3',
  GOOGLE_PROJECT_NUMBER: '982900441673',
  WSS_BASE_URL: 'wss://app.abi.com.py/ws',
}
